import React from "react";
import { getAssetUrl } from "../../config";

export default function Team() {
    return (
        <section className="section container">
            <h2 className="h-lg section-title">The mindset behind it.</h2>
            <div className="team-grid">
                <div className="team-card">
                    <div className="graphic photo">
                        <img loading="lazy" src={getAssetUrl('kds-assets/img/kudosta-cto.jpeg')} alt="Manohar Swarnkar" />
                        {/* <div className="graphic graphic--fill">
                            <span className="blob blob-p1"></span>
                            <span className="dots"></span>
                            <div className="graphic-center">
                                <span className="initials">AK</span>
                            </div>
                        </div> */}
                    </div>
                    <div className="role">Manohar Swarnkar</div>
                    <div className="area">CEO & Founder</div>
                    <div className="description">It is right that Kingdom is not built without picking up right stones. The same is the story of Mr. Manohar Swarnkar. A lead Full Stack developer, specializing in Web Development has 15+ years of experience. Earlier, he had worked as a front-end developer which made him detail-oriented. He is aware of minor technical aspects that majorly affect a software development project. Now, he owns Kudosta with determination and is working with web development agencies in Australia, the USA, the UK, Canada, and more. He believes in learning to gather knowledge of every field then implement effective strategies. This helps the company to grow like an evergreen plant.</div>
                </div>
                <div className="team-card">
                    <div className="graphic photo">
                        <img loading="lazy" src={getAssetUrl('kds-assets/img/om-pareek.png')} alt="Om Pareek" />
                        {/* <div className="graphic graphic--fill">
                            <span className="blob blob-p3"></span>
                            <span className="dots"></span>
                            <div className="graphic-center">
                                <span className="initials">PD</span>
                            </div>
                        </div> */}
                    </div>
                    <div className="role">Om Pareek</div>
                    <div className="area">Sales Coordinator</div>
                    <div className="description">Om Pareek, Sales Coordinator at Kudosta Solutions, plays a pivotal role in driving sales and fostering client relationships. With expertise in website, mobile app, and custom software development, he ensures smooth coordination between clients and development teams, delivering tailored solutions that meet business needs. His dedication and communication skills contribute significantly to Kudosta's reputation for excellence.</div>
                </div>
            </div>
        </section>
    );
}
